import { defineComponent as l, createBlock as t, openBlock as o, normalizeProps as n, guardReactiveProps as p, withCtx as c, renderSlot as s, createElementVNode as d } from "vue";
import i from "../CdrIcon.vue.mjs";
const f = /* @__PURE__ */ l({
  name: "BrandReiIceAxes",
  __name: "brand-rei-ice-axes",
  props: {
    props: {
      type: Object
    }
  },
  setup(a) {
    return (r, e) => (o(), t(i, n(p(a.props)), {
      default: c(() => [s(r.$slots, "default"), e[0] || (e[0] = d("path", {
        role: "presentation",
        d: "M14.623 2.354c.148.038.27.073.368.103a10.004 10.004 0 016.982 10.26L21.95 13l-.802-.276a1 1 0 01-.671-.874c-.137-1.9-.893-3.306-2.267-4.217L18 7.5l-4.556 4.527 7.526 7.523c.186.186.334.408.435.651l.573 1.383a.301.301 0 01-.393.393l-1.383-.573a2.007 2.007 0 01-.651-.435L12 13.463 4.447 20.97c-.149.15-.32.274-.507.37l-.144.065-1.382.573a.301.301 0 01-.413-.327l.02-.066.572-1.383a2 2 0 01.328-.535l.107-.116 7.525-7.524L6 7.5c-1.508.905-2.333 2.355-2.477 4.35a1 1 0 01-.672.874L2.05 13A10.003 10.003 0 019.008 2.457c.097-.03.22-.065.367-.103A.5.5 0 0110 2.84v.792a1 1 0 01-.56.897l-1.09.535a1 1 0 00-.267 1.605l3.915 3.914 3.918-3.914a1 1 0 00.137-.17l.053-.097a1 1 0 00-.355-1.28l-.102-.058-1.09-.535a1 1 0 01-.552-.772l-.008-.125V2.84a.5.5 0 01.447-.498l.088-.001.09.014zM6.5 5a.5.5 0 100 1 .5.5 0 000-1zm11 0a.5.5 0 100 1 .5.5 0 000-1z"
      }, null, -1))]),
      _: 3
    }, 16));
  }
});
export {
  f as default
};
